import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDiscardSellTicketProps extends ModalEditComponentProps {
    handleOnAccept: () => Promise<void>
}

const ModalDiscardSellTicket: React.FC<ModalDiscardSellTicketProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={rest.handleOnAccept} translations={{
            title: t('sureDiscardthisTicket', '¿Seguro que quieres descartar este ticket?'),
            subtitle: t('onceDiscartedNotRecoverM', 'Una vez descartado no podrás recuperarlo'),
            buttonAccept: t('discard', 'Descartar'),
            buttonCancel: t('return', 'Volver')
        }} className='text-gray-51'/>
    )
}

export default ModalDiscardSellTicket